import { createContext } from 'react';

import { type FilingStep } from '@/lib/PacerSubmissionPane/types';

/** Identifies an active filing to register with the provider. */
export type ActiveFiling = {
  userWorkflowId: string;
  submissionAttemptId: string;
};

/** Internal state for a single tracked filing. */
export type FilingProgressEntry = {
  userWorkflowId: string;
  submissionAttemptId: string;
  steps: FilingStep[];
  isCancelling: boolean;
  isFinished: boolean;
  isDismissed: boolean;
};

/** Public interface exposed by the FilingProgress context. */
export type IFilingProgressContext = {
  /** Register an active filing for global tracking. Idempotent — no-op if already tracked. */
  registerFiling: (filing: ActiveFiling) => void;
  /** Stop tracking a filing by its submission attempt ID. */
  unregisterFiling: (submissionAttemptId: string) => void;
  /** Mark a filing as dismissed so it is hidden from the UI. */
  dismissFiling: (submissionAttemptId: string) => void;
  /** Cancel a filing by its submission attempt ID. */
  cancelFiling: (submissionAttemptId: string) => void;
  /** All currently tracked filings. */
  filings: FilingProgressEntry[];
};

const FilingProgressContext = createContext<IFilingProgressContext>({
  registerFiling: () => {},
  unregisterFiling: () => {},
  dismissFiling: () => {},
  cancelFiling: () => {},
  filings: [],
});

export default FilingProgressContext;
